import React, { useEffect, useRef } from 'react';
import QrScanner from 'qr-scanner';
import './QRScanner.scss'; // Import the SCSS file
import { set } from 'date-fns';

interface QRScannerProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setQRContent: (content: string) => void;
  setQrInput:any;
}

const QRScanner: React.FC<QRScannerProps> = ({ isOpen, setIsOpen, setQRContent,setQrInput }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const qrScannerRef = useRef<QrScanner | null>(null);

  useEffect(() => {
    if (isOpen && videoRef.current) {
      qrScannerRef.current = new QrScanner(
        videoRef.current,
        (result) => {
          setQRContent(result.data);
          setQrInput(true);
          setIsOpen(false);
        },
        {
          onDecodeError: (error) => {
            console.error(error);
          },
        }
      );

      QrScanner.hasCamera().then((hasCamera) => {
        if (hasCamera) {
          qrScannerRef.current?.start();
        } else {
          console.error('No camera found.');
        }
      });
    }

    return () => {
      qrScannerRef.current?.stop();
    };
  }, [isOpen, setIsOpen, setQRContent]);

  return (
    <div style={{ textAlign: 'center' }}>
      <video 
        ref={videoRef} 
        style={{
          width: '100%',
          maxWidth: '500px',
          height: 'auto',
          border: '1px solid #ccc',
          borderRadius: '8px',
          backgroundColor: '#000',
        }}
      />
    </div>
  );
};

export default QRScanner;
